import commonDataAccess from "../commonDataAccess";
import { IFilter } from "../../@redux/listRedux";

class NearMissDataAccess {
    saveFirstAiderSignature(payload: { nearMissId: any; signature: any }) {
        return commonDataAccess.postData(
            "NearMiss/save/firstAiderSignature",
            payload
        );
    }

    NearMissList = async (params: {
        pageNo;
        pageSize;
        sortData;
        filters: Array<IFilter>;
    }) => {
        let _filters = {};
        console.log(params.filters);
        params.filters.forEach((item) => {
            if (item.value && item.value.length > 0) {
                _filters["filter." + item.propertyName] = item.value + "-" + item.type;
            }
        });
        let parameters = {
            pageNo: params.pageNo,
            pageSize: params.pageSize,
            sortPreference: params.sortData,
            ..._filters,
        };
        return await commonDataAccess.getData("NearMiss/getall", parameters);
    };
    getNearMissInfo = async (params: { id: number | bigint }) => {
        var result = await commonDataAccess.getData(
            "NearMiss/get/NearMissInfo/" + params,
            {}
        );
        return result;
    };
    getNearMissIssuesDropdowns = () => {
        return commonDataAccess.getData("NearMiss/get/NearMissIssuesDropdown");
    };
    getNearMissDropdowns = () => {
        return commonDataAccess.getData("NearMiss/get/NearMisssDropdown");
    };
    saveNearMissInfo = (data: any) => {
        var result = commonDataAccess.postData("NearMiss/save/NearMissInfo", data);
        return result;
    };
    getNearMissInjuryDetail = (params: { id: number | bigint }) => {
        return commonDataAccess.getData("NearMiss/get/injurydetails/" + params);
    };
    saveNearMissInjuryDetail = (data: any) => {
        var result = commonDataAccess.postData("NearMiss/save/injurydetails", data);
        return result;
    };
    getNearMissActionDetail = (params: { id: number | bigint }) => {
        return commonDataAccess.getData("NearMiss/get/actions/" + params);
    };
    saveNearMissActionDetail = (data: any) => {
        var result = commonDataAccess.postData("NearMiss/save/actions", data);
        return result;
    };
    deleteNearMissInfo = async (params: { ids: string }) => {
        var result = await commonDataAccess.deleteData("NearMiss/delete/" + params);
        return result;
    };
}

export default new NearMissDataAccess();
